import PropTypes from 'prop-types';
import { propTypes as cityPropTypes } from './City';
import { propTypes as countryPropTypes } from './Country';

export const propTypes = {
  id: PropTypes.string,
  city: PropTypes.shape(cityPropTypes),
  country: PropTypes.shape(countryPropTypes)
};

export const defaultProps = {
  id: null,
  city: null,
  country: {}
};

export default { defaultProps, propTypes };
